'use client';

import { ContentSize } from "@/frontend/components/ui/section";
import { Logo } from "@/frontend/components/layout/logo";
import { LangSwitcher } from "@/frontend/components/layout/navigation/lang-switcher";
import { useRef } from "react";
import { Navigation } from "@/payload-types";
import { NavigationVariable } from "./navigation-variable";
import { NavigationBlock } from "@/frontend/components/layout/navigation/navigation-block";
import './styles.scss';
import { GradientBlur } from "../../ui/common/gradiant-blur";
import { Button } from "../../ui/button";
import { useTranslations } from "next-intl";

const NavigationWrapper = ({ docs } : { docs: Navigation }) => {
  const navigationWrapperRef = useRef(null);
  const t = useTranslations('Navigation');

  return (
    <header>
      <div className="navigation-container">
        <ContentSize>
          <div className="navigation-wrapper">
            <div className="left"><LangSwitcher /></div>
            <div className="center"><Logo /></div>
            <div className="right">
              { docs?.items?.length ? 
                <NavigationBlock docs={docs} /> : 
                <Button variant={'0'} icon={'none'} size={'small'} href="#contact">{t('contact')}</Button>
              }
            </div>
            <GradientBlur direction="top" />
          </div>
        </ContentSize>
      </div>
      <NavigationVariable navigationWrapperRef={navigationWrapperRef} />
    </header>
  );
};
NavigationWrapper.displayName = 'Navigation';

export { NavigationWrapper };